const NoMatch = () => (
  <h1>Sorry, the page you requested could not be found! 🦄</h1>
)

export default NoMatch
